/* eslint-disable @typescript-eslint/no-explicit-any */
import { getStorege, removeStorege, updateRequestStorege } from '../db_storage';
import { checkCartStorege } from '../utils/Check';

export const handleSaveFlavorCartStorage = (
  flavor: any,
  params: any,
  type: string,
  key: string,
): any => {
  let checkDateTime = false;
  const dataShopResquetStorage = getStorege(key);

  if (dataShopResquetStorage?.dateTimeRequest) {
    checkDateTime = checkCartStorege(
      dataShopResquetStorage.dateTimeRequest,
      60,
    );
    if (checkDateTime) {
      removeStorege(key);
      return { remove: true };
    }
  }

  if (
    params.qtSabores > 0 &&
    dataShopResquetStorage?.sabor?.length >= params.qtSabores
  ) {
    return { qtMax: true };
  }

  const idShopStorege = dataShopResquetStorage?.idRestaurante
    ? window.atob(dataShopResquetStorage?.idRestaurante)
    : 0;

  if (idShopStorege === params.idShop) {
    let resultUpdate;

    flavor.forEach((flavoItem: any) => {
      resultUpdate = updateRequestStorege(
        key,
        {
          idPedidoCardapio: params.idPedidoCardapio,
          qtItens: 1,
          vlSabor: flavoItem.vlSabor,
          idSabor: flavoItem.idSabor,
          dsDescricao: flavoItem.dsDescricao,
          dsSabor: flavoItem.dsSabor,
          idCardapio: params.idCardapio,
        },
        type,
      );
    });

    return resultUpdate;
  }

  return { remove: true };
};
